import React, { useState, useEffect } from 'react';

const AddLessonModal = ({ open, onClose, onSave, date, students = {}, groups = {}, initialTime = '09:00', saving = false }) => {
  const [itemType, setItemType] = useState('lesson'); // 'lesson' or 'event'
  const [selectedId, setSelectedId] = useState('');
  const [title, setTitle] = useState('');
  const [from, setFrom] = useState(initialTime);
  const [to, setTo] = useState(() => {
    // Устанавливаем время окончания на час позже начального времени
    const [hours, minutes] = initialTime.split(':').map(Number);
    const endHours = hours + 1;
    return `${endHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  });
  const [repeatWeekly, setRepeatWeekly] = useState(false);
  const [allDay, setAllDay] = useState(false);
  const [errors, setErrors] = useState([]);

  // Функция для автоматического обновления времени окончания
  const updateToTime = (newFromTime) => {
    if (!newFromTime || typeof newFromTime !== 'string') return '10:00';
    const parts = newFromTime.split(':').map(Number);
    const hours = Number.isFinite(parts[0]) ? parts[0] : 9;
    const minutes = Number.isFinite(parts[1]) ? parts[1] : 0;
    const endHours = hours + 1;
    return `${endHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  };

  // Функция валидации
  const validateForm = () => {
    console.log('🔍 validateForm called');
    console.log('🔍 itemType:', itemType);
    console.log('🔍 selectedId:', selectedId);
    console.log('🔍 title:', title);
    console.log('🔍 from:', from);
    console.log('🔍 to:', to);
    console.log('🔍 allDay:', allDay);

    const newErrors = [];

    // Проверка времени (только если не all-day)
    if (!allDay) {
      if (!from || !to) {
        newErrors.push('Please select both start and end time');
      } else if (from >= to) {
        newErrors.push('End time must be after start time');
      }
    }

    // Проверка студента/группы для уроков
    if (itemType === 'lesson' && !selectedId) {
      newErrors.push('Please select a student or group');
    }

    // Проверка названия для событий
    if (itemType === 'event' && !title.trim()) {
      newErrors.push('Please enter an event title');
    }

    console.log('🔍 newErrors:', newErrors);
    setErrors(newErrors);
    return newErrors.length === 0;
  };

  useEffect(() => {
    if (open) {
      setItemType('lesson');
      setSelectedId('');
      setTitle('');
      setFrom(initialTime);
      const [hours, minutes] = initialTime.split(':').map(Number);
      const endHours = hours + 1;
      setTo(`${endHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`);
      setRepeatWeekly(false);
      setAllDay(false);
      setErrors([]); // Очищаем ошибки при открытии
    }
  }, [open, initialTime]);

  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Add {itemType === 'lesson' ? 'Lesson' : 'Event'}</h3>
        {errors.length > 0 && (
          <div style={{
            background: '#f8d7da',
            color: '#721c24',
            padding: '10px',
            borderRadius: '4px',
            marginBottom: '15px',
            fontSize: '13px'
          }}>
            {errors.map((error, index) => (
              <div key={index} style={{ marginBottom: '4px' }}>
                • {error}
              </div>
            ))}
          </div>
        )}
        <div className="modal-row">
          <label>Type:</label>
          <select value={itemType} onChange={e => setItemType(e.target.value)}>
            <option value="lesson">Lesson</option>
            <option value="event">Event</option>
          </select>
        </div>
        <div className="modal-row">
          <label>Date:</label>
          <span>{date.toDateString()}</span>
        </div>
        <div className="modal-row">
          <label>From:</label>
          <input
            type="time"
            value={from}
            onChange={e => {
              const newFrom = e.target.value;
              setFrom(newFrom);
              // Автоматически устанавливаем время окончания на час позже
              setTo(updateToTime(newFrom));
            }}
          />
        </div>
        <div className="modal-row">
          <label>To:</label>
          <input type="time" value={to} onChange={e => setTo(e.target.value)} />
        </div>
        {itemType === 'lesson' ? (
          <div className="modal-row">
            <label>Student/Group:</label>
            <select value={selectedId} onChange={e => setSelectedId(e.target.value)}>
              <option value="">Select student or group</option>
              {Object.keys(groups).length > 0 && (
              <optgroup label="Groups">
                  {Object.entries(groups).map(([id, g]) => (
                  <option key={`group-${id}`} value={`group-${id}`}>● {g.name}</option>
                ))}
              </optgroup>
              )}
              {Object.keys(students).length > 0 && (
              <optgroup label="Students">
                  {Object.entries(students).map(([id, s]) => (
                  <option key={`student-${id}`} value={`student-${id}`}>○ {s.name}</option>
                ))}
              </optgroup>
              )}
              {Object.keys(groups).length === 0 && Object.keys(students).length === 0 && (
                <option value="" disabled>Loading students and groups...</option>
              )}
            </select>
          </div>
        ) : (
          <div className="modal-row">
            <label>Title:</label>
            <input
              type="text"
              value={title}
              onChange={e => setTitle(e.target.value)}
              placeholder="Event title"
            />
          </div>
        )}
        <div className="modal-row">
          <label></label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <input type="checkbox" checked={repeatWeekly} onChange={e => setRepeatWeekly(e.target.checked)} />
            Repeat every week
          </label>
        </div>
        <div className="modal-row">
          <label></label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <input type="checkbox" checked={allDay} onChange={e => setAllDay(e.target.checked)} />
            All day event
          </label>
        </div>
        <div className="modal-actions">
          <button onClick={onClose} disabled={saving}>Cancel</button>
          <button
            onClick={() => {
              console.log('🔘 Add button clicked');
              const isValid = validateForm();
              console.log('🔘 validateForm result:', isValid);
              if (isValid) {
                console.log('🔘 Calling onSave with date:', date);
                onSave({
                  type: itemType,
                  selectedId,
                  title,
                  from,
                  to,
                  repeatWeekly,
                  allDay
                }, date);
              } else {
                console.log('🔘 Form is invalid, not calling onSave');
              }
            }}
            disabled={saving}
            className={`schedule-modal-add-btn${saving ? ' schedule-add-btn-loading' : ''}`}
          >
            {saving ? (
              <span className="schedule-add-btn-spinner" aria-hidden />
            ) : (
              'Add'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddLessonModal;
